import React from 'react';

/** 功放详情页专用 i18n 边界，语言状态与全站系统相互独立。 */
export const AmplifierI18nProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>{children}</>
);

export default AmplifierI18nProvider;
